import Vue from 'vue'
import Router from 'vue-router'
import HomeHeader from '@/components/homeHeader'
import HomeFooter from '@/components/homeFooter'
import IndexHeader from '@/components/indexHeader'
import BbsPdf from '@/components/bbsPdf'
import Home from '@/pages/home'
import NewsList from '@/pages/newsList'
import NewsDetails from '@/pages/newsDetails'
import TeacherTroop from '@/pages/teacherTroop'
import TeacherCenter from '@/pages/teacherCenter'
import SchoolProfile from '@/pages/schoolProfile'
import EduDba from '@/pages/eduDba'
import EduMba from '@/pages/eduMba'
import EduData from '@/pages/eduData'
import EduFinance from '@/pages/eduFinance'
import EduManger from '@/pages/eduManger'
import EduGlx from '@/pages/eduGlx'
import EduDzsw from '@/pages/eduDzsw'
import EduGjsw from '@/pages/eduGjsw'
import EduApply from '@/pages/eduApply'
import MasterAccount from '@/pages/masterAccount'
import EduScyx from '@/pages/eduScyx'
import EduYyxlBs from '@/pages/eduYyxlBs'
// import StudentSearch from '@/pages/studentSearch'
import PubPdf from '@/pages/pdf/pubPdf'
import EnglishPdf from '@/pages/pdf/englishPdf'
import BrestBs from '@/pages/pdf/brestBs'
import PdfDba from '@/pages/pdf/pdfDba'
import PdfMba from '@/pages/pdf/pdfMba'
import EduJrong from '@/pages/pdf/eduJrong'
import EduNumber from '@/pages/pdf/eduNumber'
import EduShuju from '@/pages/pdf/eduShuju'
import PdfGlx from '@/pages/pdf/pdfGlx'
import HealthMBAPdf from '@/pages/pdf/healthMBAPdf'
import HealthDBAPdf from '@/pages/pdf/healthDBAPdf'
import PdfDzsw from '@/pages/pdf/pdfDzsw'
import PdfGjsw from '@/pages/pdf/pdfGjsw'
import PdfApply from '@/pages/pdf/pdfApply'
import PdfScyx from '@/pages/pdf/pdfScyx'
import YyxlBs from '@/pages/pdf/yyxlBs'
import BbsAccount from '@/pages/pdf/bbsAccount'
import Index from '@/pages/a/index'
import HealthMba from '@/pages/healthMba'
import HealthDba from '@/pages/healthDba'


import SchoolAlumni from '@/pages/schoolAlumni'  //校友会
import CenterPage from '@/pages/admissions/centerPage'
import AgentPage from '@/pages/admissions/agentPage'
import ConsultPage from '@/pages/admissions/consultPage'
import HealthPage from '@/pages/admissions/healthPage'
import FoodPage from '@/pages/admissions/foodPage'
import RecruitmentPage from '@/pages/admissions/recruitmentPage'

// 人才培养
import CollegePage from '@/pages/education/collegePage'
import EntrepreneursPage from '@/pages/education/entrepreneursPage'
import HignEduPage from '@/pages/education/hignEduPage'
import LifePage from '@/pages/education/lifePage'
import PsychologyPage from '@/pages/education/psychologyPage'
// h5宣传页  advertisePage
import H5Page from '@/pages/h5/h5Page'
import H5OrderInfo from '@/pages/h5/h5OrderInfo'
import AdvertisePage from '@/pages/h5/advertisePage'
import BbsPromotePage from '@/pages/h5/bbsH5/bbsPromotePage'
// 实践与创新
import Innovation from '@/pages/innovation'
// 校友风采
import AlumniStyle from '@/pages/alumni-style/index'
import AlumniDetail from '@/pages/alumni-style/alumniDetail'
import EduMbaLean from  '@/pages/eduMbaLean'
import EduDbaOnline from  '@/pages/eduDbaOnline'
import EduDbaLean from  '@/pages/eduDbaLean'
import EduMbaAi from  '@/pages/eduMbaAi'
import MadmVue from  '@/pages/madmVue'
import EduDarmVue from  '@/pages/eduDarmVue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/bbsPromotePage',
      name: 'BbsPromotePage',
      component: BbsPromotePage,
      meta: {
        keepAlive: false,
        title: '布雷斯特高等商学院',
      }
    },
    {
      path: '/h5Page',
      name: 'h5Page',
      component: H5Page
    },
    {
      path: '/h5OrderInfo', //返回根路径
      name: 'h5OrderInfo',
      component: H5OrderInfo
    },
    {
      path: '/advertisePage', //易经宣传页
      name: 'advertisePage',
      component: AdvertisePage,
      meta: {
        title: '布雷斯特商学院APP客户端下载'
      }
    },
    {
      path: 'homeHeader',
      name: 'HomeHeader',
      component: HomeHeader
    },
    {
      path: 'indexHeader',
      name: 'IndexHeader',
      component: IndexHeader
    },
    {
      path: 'bbsPdf',
      name: 'BbsPdf',
      component: BbsPdf
    },
    {
      path: 'bbsAccount',
      name: 'BbsAccount',
      component: BbsAccount
    },

    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/newsList',
      name: 'NewsList',
      component: NewsList,
      meta: {
        keepAlive: false,
        title: '新闻列表',
      }
    },
    {
      path: '/newsDetails',
      name: 'NewsDetails',
      component: NewsDetails
    },
    {
      path: '/teacherTroop',
      name: 'TeacherTroop',
      component: TeacherTroop,
      meta: {
        keepAlive: false,
        title: '布雷斯特高等商学院',
      }
    },
    {
      path: '/teacherCenter',
      name: 'TeacherCenter',
      component: TeacherCenter,
      meta: {
        keepAlive: false,
        title: '教学中心',
      }
    },
    {
      path: '/schoolProfile',
      name: 'SchoolProfile',
      component: SchoolProfile,
      meta: {
        keepAlive: false,
        title: '学院概况',
      }
    },
    {
      path: '/eduDba',
      name: 'EduDba',
      component: EduDba,
      meta: {
        keepAlive: false,
        title: '开设专业-DBA',
      }
    },
    {
      path: '/eduMba',
      name: 'EduMba',
      component: EduMba,
      meta: {
        keepAlive: false,
        title: '开设专业-MBA',
      }
    },
    {
      path: '/eduData',
      name: 'EduData',
      component: EduData,
      meta: {
        keepAlive: false,
        title: '开设专业-MBA',
      }
    },
    {
      path: '/eduFinance',
      name: 'EduFinance',
      component: EduFinance,
      meta: {
        keepAlive: false,
        title: '开设专业-MBA',
      }
    },
    {
      path: '/eduManger',
      name: 'EduManger',
      component: EduManger,
      meta: {
        keepAlive: false,
        title: '开设专业-MBA',
      }
    },
    {
      path: '/eduGlx',
      name: 'EduGlx',
      component: EduGlx,
      meta: {
        keepAlive: false,
        title: '开设专业-管理学',
      }
    },
    {
      path: '/eduDzsw',
      name: 'EduDzsw',
      component: EduDzsw,
      meta: {
        keepAlive: false,
        title: '开设专业-国际商务管理硕士',
      }
    },
    {
      path: '/eduScyx',
      name: 'EduScyx',
      component: EduScyx,
      meta: {
        keepAlive: false,
        title: '开设专业-市场营销管理硕士',
      }
    },
    {
      path: '/eduYyxlBs',
      name: 'EduYyxlBs',
      component: EduYyxlBs,
      meta: {
        keepAlive: false,
        title: '开设专业-应用心理学与管理博士',
      }
    },
    {
      path: '/eduGjsw',
      name: 'EduGjsw',
      component: EduGjsw,
      meta: {
        keepAlive: false,
        title: '开设专业-国际商务管理',
      }
    },
    {
      path: '/eduApply',
      name: 'EduApply',
      component: EduApply,
      meta: {
        keepAlive: false,
        title: '开设专业-应用心理学与管理硕士',
      }
    },
    {
      path: '/masterAccount',
      name: 'MasterAccount',
      component: MasterAccount,
      meta: {
        keepAlive: false,
        title: '开设专业-会计与管理硕士',
      }
    },
    {
      path: '/healthMba',
      name: 'HealthMba',
      component: HealthMba,
      meta: {
        keepAlive: false,
        title: '开设专业-健康管理硕士',
      }
    },
    {
      path: '/healthDba',
      name: 'HealthDba',
      component: HealthDba,
      meta: {
        keepAlive: false,
        title: '开设专业-健康管理博士',
      }
    },
    {
      path: '/healthMBAPdf',
      name: 'HealthMBAPdf',
      component: HealthMBAPdf
    },
    {
      path: '/healthDBAPdf',
      name: 'HealthDBAPdf',
      component: HealthDBAPdf
    },

    // {
    //     path: '/studentSearch',
    //     name: 'StudentSearch',
    //     component: StudentSearch,
    //     meta: {
    //         keepAlive: false,
    //         title: '入学查询',
    //     }
    // },
    {
      path: '/schoolAlumni',
      name: 'SchoolAlumni',
      component: SchoolAlumni,
      meta: {
        keepAlive: false,
        title: '校友会',
      }
    },
    {
      path: '/centerPage',
      name: 'CenterPage',
      component: CenterPage,
    },
    {
      path: '/agentPage',
      name: 'AgentPage',
      component: AgentPage,
    },
    {
      path: '/consultPage',
      name: 'ConsultPage',
      component: ConsultPage,
    },
    {
      path: '/healthPage',
      name: 'HealthPage',
      component: HealthPage,
    },
    {
      path: '/foodPage',
      name: 'FoodPage',
      component: FoodPage,
    },
    {
      path: '/recruitmentPage',
      name: 'RecruitmentPage',
      component: RecruitmentPage,
    },
    {
      path: '/collegePage',
      name: 'CollegePage',
      component: CollegePage,
    },
    {
      path: '/entrepreneursPage',
      name: 'EntrepreneursPage',
      component: EntrepreneursPage,
    },
    {
      path: '/hignEduPage',
      name: 'HignEduPage',
      component: HignEduPage,
    },
    {
      path: '/lifePage',
      name: 'LifePage',
      component: LifePage,
    },
    {
      path: '/psychologyPage',
      name: 'PsychologyPage',
      component: PsychologyPage,
    },
    {
      path: '/pubPdf',
      name: 'PubPdf',
      component: PubPdf
    },
    {
      path: '/englishPdf',
      name: 'EnglishPdf',
      component: EnglishPdf
    },
    {
      path: '/brestBs',
      name: 'BrestBs',
      component: BrestBs
    },
    {
      path: '/pdfDba',
      name: 'PdfDba',
      component: PdfDba
    },
    {
      path: '/pdfMba',
      name: 'PdfMba',
      component: PdfMba
    },
    {
      path: '/eduNumber',
      name: 'EduNumber',
      component: EduNumber
    },
    {
      path: '/eduJrong',
      name: 'EduJrong',
      component: EduJrong
    },
    {
      path: '/eduShuju',
      name: 'EduShuju',
      component: EduShuju
    },
    {
      path: '/pdfGlx',
      name: 'PdfGlx',
      component: PdfGlx
    },
    {
      path: '/pdfGjsw',
      name: 'PdfGjsw',
      component: PdfGjsw
    },
    {
      path: '/pdfDzsw',
      name: 'PdfDzsw',
      component: PdfDzsw
    },
    {
      path: '/pdfApply',
      name: 'PdfApply',
      component: PdfApply
    },
    {
      path: '/pdfScyx',
      name: 'PdfScyx',
      component: PdfScyx
    },
    {
      path: '/yyxlBs',
      name: 'YyxlBs',
      component: YyxlBs
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      meta: {
        keepAlive: false,
        title: '海纳易学服务协议',
      }
    },
    {
      path: '/innovation',
      name: 'innovation',
      component: Innovation
    },
    {
      path: '/alumniStyle',
      name: 'alumniStyle',
      component: AlumniStyle,
      meta: {
        keepAlive: false,
        title: '校友风采',
      }
    },
    {
      path: '/alumniDetail',
      name: 'alumniDetail',
      component: AlumniDetail,
      meta: {
        keepAlive: false,
        title: '校友风采',
      }
    },
    {
      path: '/eduMbaLean',
      name: 'eduMbaLean',
      component: EduMbaLean,
      meta: {
        keepAlive: false,
        title: '工商管理硕士(精益管理方向)',
      }
    },
    {
      path: '/eduDbaLean',
      name: 'eduDbaLean',
      component: EduDbaLean,
      meta: {
        keepAlive: false,
        title: '工商管理博士(精益管理方向)',
      }
    },
    {
      path: '/eduDbaOnline',
      name: 'eduDbaOnline',
      component: EduDbaOnline,
      meta: {
        keepAlive: false,
        title: '工商管理博士(online)',
      }
    },
    {
      path: '/eduMbaAi',
      name: 'eduMbaAi',
      component: EduMbaAi,
      meta: {
        keepAlive: false,
        title: '工商管理硕士(AI应用方向)',
      }
    },
    {
      path: '/madmVue',
      name: 'madmVue',
      component: MadmVue,
      meta: {
        keepAlive: false,
        title: '艺术设计与管理硕士',
      }
    },
    {
      path: '/eduDarm',
      name: 'eduDarm',
      component: EduDarmVue,
      meta: {
        keepAlive: false,
        title: '人工智能应用与管理博士',
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js